// Logica pura de la vista "por agente" de la pestaña de permisos: invierte
// usuario -> agentes en agente -> usuarios y aplica la busqueda. Fuera del
// componente para que lo que corre la UI se pueda probar aislado, igual que
// `userTable.ts` para la vista por usuario.

export type AgenteAsignable = { graph_id: string; hitl?: boolean };

export type FilaAgente = {
  graphId: string;
  /** Emails que se pintan: todos, o solo los que casan con la busqueda. */
  emails: string[];
  /** Usuarios con acceso SIN filtrar: el contador no cambia al buscar. */
  total: number;
  hitl: boolean;
  /**
   * false = aparece en algun `allowed_agents` pero ya no esta registrado. El
   * backend responde 422 a un agente desconocido, asi que la vista lo pinta en
   * solo lectura en vez de ofrecer botones que fallarian.
   */
  registrado: boolean;
  /** La fila entra por casar un EMAIL, no el agente: se pinta desplegada. */
  casaPorEmail: boolean;
};

export function usuariosPorAgente(
  users: { email: string; allowed_agents: string[] }[],
  asignables: AgenteAsignable[],
  registrados: ReadonlySet<string>,
  busqueda: string,
  etiqueta: (graphId: string) => string,
): FilaAgente[] {
  const porAgente = new Map<string, Set<string>>();
  for (const u of users) {
    for (const a of u.allowed_agents) {
      if (!porAgente.has(a)) porAgente.set(a, new Set());
      porAgente.get(a)!.add(u.email);
    }
  }

  const ids = asignables.map((a) => a.graph_id);
  const hitl = new Map(asignables.map((a) => [a.graph_id, !!a.hitl]));
  // Asignados pero no asignables: los registrados primero y los huerfanos al
  // final, que es donde se leen como "esto sobra".
  const extra = [...porAgente.keys()]
    .filter((id) => !ids.includes(id))
    .sort((a, b) => Number(registrados.has(b)) - Number(registrados.has(a)) || a.localeCompare(b));

  const q = busqueda.trim().toLowerCase();
  const filas: FilaAgente[] = [];
  for (const id of [...ids, ...extra]) {
    const todos = [...(porAgente.get(id) ?? [])].sort();
    const base = { graphId: id, total: todos.length, hitl: hitl.get(id) ?? false, registrado: registrados.has(id) };
    if (!q || id.toLowerCase().includes(q) || etiqueta(id).toLowerCase().includes(q)) {
      filas.push({ ...base, emails: todos, casaPorEmail: false });
      continue;
    }
    const casan = todos.filter((e) => e.toLowerCase().includes(q));
    if (casan.length > 0) filas.push({ ...base, emails: casan, casaPorEmail: true });
  }
  return filas;
}
